import { functions } from '@/functions';

export const functions_program = {
    mixins: [functions],
    data: function () {
        return {
            programs: [],
            program: null,
        }
    },

    methods: {

        loadPrograms: function (hotel_id, onSuccess = null, param = null) {
            if (!this.isProgramsLoaded() && hotel_id) {
                this.programs = [];
                this.httpPrepare();
                let self = this;
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/programs')).then(function (response) {
                    response = this.httpSuccess(response);
                    self.programs = response.payload;
                    self.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetPrograms: function () {
            this.programs = [];
            return this;
        },

        isProgramsLoaded: function () {
            return this.is(this.programs) && this.programs.length;
        },

        getProgramTitleById: function (id, programs = null) {
            if (!this.is(id)) {
                return 'не указано';
            }
            console.log(1, id, programs)

            if (programs === null) {
                programs = this.programs;
            }

            console.log(2, programs)

            for (let i = 0; i < programs.length; i++) {
                if (programs[i].id === id) {
                    return programs[i].title;
                }
            }
            return 'program непонятка (#' + id + ')';
        },

        getProgramById: function (id, programs = null) {
            if (!this.is(id)) return null;
            if (programs === null) programs = this.programs;
            for (let i = 0; i < programs.length; i++) {
                if (programs[i].id === id) {
                    return programs[i];
                }
            }
            return null;
        },

        delProgramById: function (id, programs = null) {
            if (!this.is(id)) return false;
            if (programs === null) programs = this.programs;

            for (let i = 0; i < programs.length; i++) {
                if (programs[i].id === id) {
                    programs.splice(i, 1);
                    return true;
                }
            }
            return false;
        },

        loadProgram: function (program_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('program/' + program_id )).then(function (response) {
                response = this.httpSuccess(response);
                this.program = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        enableProgram: function (program_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('program/' + program_id + '/enable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        disableProgram: function (program_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('program/' + program_id + '/disable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        deleteProgram: function (program_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('program/' + program_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        createProgram: function (hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('program/create/' + hotel_id  )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                this.setLatestProgram(response.payload.id);
            }, this.httpError)
        },

        cloneProgram: function (program_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('program/' + program_id + '/clone'  )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                this.setLatestProgram(response.payload.id);
            }, this.httpError)
        },

        saveProgram: function (onSuccess=null, param) {
            this.httpPrepare();
            let self = this;
            this.$http.put(this.apiurl('program/'+this.program.id+'/save'), this.program).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                this.setLatestProgram(self.program.id);
            }, this.httpError)
        },

        latestProgramClass: function (program) {
            return this.isLatest('App\\Models\\Program', program.id) ? 'latest' : '';
        },
        setLatestProgram: function (id) {
            this.setLatest('App\\Models\\Program', id);
        },

    },

    computed: {
        is_program_loaded: function () {
            return (this.is(this.program));
        },

        booker_program_id: {
            set: function (val) {
                this.program.prof_obj_tariff_id = val;
            },
            get: function () {
                return this.program.prof_obj_tariff_id;
            },
        },
    }
};
